/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/screen_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});

/* ========== ~~~~~~~~~~ SCREEN : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary


const Screen = (props) => (
    <div className={`screen ${sheet.classes.screen} ${props.name} ${props.visible ? 'active' : 'inactive'}`}>
        <div className={`screeninterior`}>
            {props.content}
        </div>
    </div>
);


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Screen;
